/* eslint-disable react-hooks/exhaustive-deps */
import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { fetchPhpEigth } from 'api';
import BreadCrumb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import DynamicForm from 'components/DynamicForm';
import ModalContratante from 'components/ModalMex/ModalContratante';
import Page from 'components/Page';
import EmisionFooterBarButtons from 'components/Polizas/EmisionFooterBarButtons';
import { SELECTORES_CSS } from 'constants/albert_events';
import { urlGuardarContratantePymes, urlSeccionCargaContratante } from 'constants/urls';
import { useNavbarContext } from 'contexts/NavbarContext';
import useCustomForm from 'hooks/useCustomForm';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { mappRutasEmision } from 'utils/funciones';
import Loading from 'wrappers/Loading';

const HogarEmisionContratante = ({ qParams: { idPoliza, codProducto }, history }) => {
  const methods = useCustomForm({ mode: 'onChange' });
  const { addWarningToast, addSuccessToast } = useCustomToast();
  const [catalogo, setCatalogo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [idCot, setIdCot] = useState('');

  const [routes, setRoutes] = useState({});
  useNavbarContext(PRODUCTOS.HOGAR);

  const init = useCallback(async () => {
    setLoading(true);

    const Body = {
      polCodigo: idPoliza,
      prodCodigo: codProducto,
      pasoRevContratante: 'obtenerContratante',
      pasoCatContratante: 'catalogoContratante',
      formulario: 'contratante',
      formCodigo: `form${codProducto}`,
      datosCotizador: {
        formCodigo: `form${codProducto}`,
      },
    };
    console.log('BODY', Body);
    const res = await fetchPhpEigth(urlSeccionCargaContratante, Body);
    console.log(res);
    if (res?.transaccion && res?.data) {
      const { catalogo } = res?.data;
      setIdCot(catalogo?.idCotizacion);
      if (!catalogo?.camposAdicionales?.permitirEmitir) {
        addWarningToast('No se puede emitir esta póliza', {
          autoDismiss: false,
        });
      }

      if (catalogo?.DatosContratanteAsegurado) {
        methods.reset({
          ...catalogo.DatosContratanteAsegurado,
        });
      }

      setRoutes(mappRutasEmision(catalogo?.pasosRedireccionamiento));
      setCatalogo(catalogo);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  const guardarInformacion = async (data, guardarDatos = true) => {
    setLoading(true);
    const Data = {
      prodCodigo: codProducto,
      idPoliza,
      guardarDatos,
      datosContratanteAsegurado: data,
    };
    const res = await fetchPhpEigth(urlGuardarContratantePymes, Data);
    console.log('DATA: ', Data);
    setLoading(false);
    init();
    console.log('RES: ', res);
    return res;
  };

  const onSubmit = async (data) => {
    console.log('DATA: ', JSON.stringify(data));
    const res = await guardarInformacion(data, false);
    if (res?.transaccion === true) {
      history.push(routes.contratante.goTo);
    }
  };

  const onGuardar = async () => {
    const isValid = await methods.trigger('tipoPersona');
    if (isValid) {
      const data = methods.getValues();
      console.log('contratante es', data);
      await guardarInformacion(data);
      addSuccessToast('Se ha guardado la información de forma correcta');
    } else {
      addWarningToast('Debe seleccionar un tipo de persona');
    }
  };

  const onClickAtras = () => {
    //history.push(`hogar3/${idCot}`);
    history.push(`/facturacion/tipo-persona?idPoliza=${idPoliza}&codProducto=${codProducto}`);
  };

  const onSubmitError = () => {
    addWarningToast('Rellene el formulario correctamente');
  };

  return (
    <React.Fragment>
      <Loading loading={loading}>
        {catalogo?.DatosContratanteAsegurado && <ModalContratante catalogo={catalogo} />}
        <div className="row justify-content-center mx-2">
          <div className="col-12">
            <div className="cr-content">
              <FormProvider {...methods}>
                <form>
                  <Page styles={{ minHeight: '80vh' }}>
                    {[PRODUCTOS.HOGAR, PRODUCTOS.HOGAR_DTC].includes(codProducto) && (
                      <React.Fragment>
                        <BreadCrumb {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR].breadCrumb} />

                        <BreadCrumbPasosV2
                          {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasosEmision[4]}
                          pasos={PASOS_BREADCRUMBS[codProducto].pasosEmision}
                        />
                      </React.Fragment>
                    )}
                    {[PRODUCTOS.HOGAR_FLEX].includes(codProducto) && (
                      <React.Fragment>
                        <BreadCrumb {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR].breadCrumb} />

                        <BreadCrumbPasosV2
                          {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasosEmision[5]}
                          pasos={PASOS_BREADCRUMBS[codProducto].pasosHogarFlex}
                        />
                      </React.Fragment>
                    )}
                    <DynamicForm {...catalogo?.validaciones} resources={catalogo} />
                  </Page>
                </form>
              </FormProvider>
              {/* <EmisionFooterBarButtons
              labelAtras='ATRÁS'
              onClickAtras={onClickAtras}
              onClickGuardar={onGuardar}
              onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
            /> */}
              <EmisionFooterBarButtons
                onClickAtras={onClickAtras}
                onClickGuardar={onGuardar}
                onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
                btnContinuarClassName={SELECTORES_CSS.HOGAR.btnContinuarContratante}
              />
            </div>
          </div>
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default withValidarRecuperar(HogarEmisionContratante);
